import { render, staticRenderFns } from "./PVBankAccountCreate.vue?vue&type=template&id=57af62a2&scoped=true&lang=pug"
import script from "./PVBankAccountCreate.vue?vue&type=script&lang=js"
export * from "./PVBankAccountCreate.vue?vue&type=script&lang=js"
import style0 from "./PVBankAccountCreate.vue?vue&type=style&index=0&id=57af62a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57af62a2",
  null
  
)

export default component.exports